import type { EntityConfig } from '../types'

export const mmAccountEntity: EntityConfig = {
  name: 'mm-account',
  label: 'Account',
  pluralLabel: 'Accounts',
  status: {
    field: 'status',
    options: [
      { value: 'active', label: 'Active', variant: 'success' },
      { value: 'frozen', label: 'Frozen', variant: 'destructive' },
      { value: 'closed', label: 'Closed', variant: 'secondary' },
      { value: 'pending', label: 'Pending', variant: 'warning' },
    ],
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'frozen', label: 'Frozen' },
      { value: 'closed', label: 'Closed' },
      { value: 'pending', label: 'Pending' },
    ],
    mappings: {
      all: ['active', 'frozen', 'closed', 'pending'],
      active: ['active'],
      frozen: ['frozen'],
      closed: ['closed'],
      pending: ['pending'],
    }
  },
  queryFields: {
    name: { field: 'name', type: 'text' },
    type: { field: 'type', type: 'text' },
    currency: { field: 'currency', type: 'text' },
    bankName: { field: 'bankName', type: 'text' },
  },
  uiFilterFields: ['status', 'type', 'currency'],
}
